// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
Rails.start();

const Turbolinks = require("turbolinks");
// Turbolinks がページを読み直すとき（turbolinks-visit-control="reload" のページへ移るとき・CSS や JS が
// 新しくなったとき）は、URL を先に移してから location.reload() する。ブラウザは読み直し前の
// スクロール位置を戻すので、前のページで下まで読んでいると、次のページが途中から表示されていた。
// 新しいページへ進むときは、読み直す直前に一番上へ戻しておく。
// そのとき前のページの位置を sessionStorage に覚え、「戻る」で読み直したときにその位置へ戻す
// （Turbolinks は位置をメモリにしか持たないので、読み直すと忘れてしまう）。
const SCROLL_KEY = "circus:scroll:";
const RESTORE_KEY = "circus:restore";
const TOP_KEY = "circus:top";
const store = {
  get(key) { try { return window.sessionStorage.getItem(key); } catch (e) { return null; } },
  set(key, value) { try { window.sessionStorage.setItem(key, value); } catch (e) { /* 保存できなくても動く */ } },
  remove(key) { try { window.sessionStorage.removeItem(key); } catch (e) { /* 同上 */ } },
};
let shownURL = window.location.href;
document.addEventListener("turbolinks:load", () => { shownURL = window.location.href; });

const turbolinksReload = Turbolinks.BrowserAdapter.prototype.reload;
Turbolinks.BrowserAdapter.prototype.reload = function () {
  const visit = Turbolinks.controller && Turbolinks.controller.currentVisit;
  if (visit && visit.action === "restore") {
    store.set(RESTORE_KEY, window.location.href);
  } else {
    store.set(SCROLL_KEY + shownURL, String(Math.round(window.scrollY)));
    window.scrollTo(0, 0);
    // Chrome は URL が移った時点の位置（と、そこにあった要素の目印）を覚えていて、読み直したあとに戻そうとする。
    // 新しいページへ進むときは戻させない（読み込み後に auto へ戻す）
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
      store.set(TOP_KEY, window.location.href);
    }
  }
  return turbolinksReload.apply(this, arguments);
};
// 上で manual にしたページは、読み込みが終わってから元の auto に戻す（以後の「戻る」「再読み込み」はふつうどおり）
if (store.get(TOP_KEY) === window.location.href) {
  store.remove(TOP_KEY);
  window.addEventListener("load", () => {
    setTimeout(() => { window.history.scrollRestoration = "auto"; }, 1000);
  }, { once: true });
}
// 「戻る」で読み直したページは、画像が並んで高さが決まってから覚えていた位置へ
if (store.get(RESTORE_KEY) === window.location.href) {
  store.remove(RESTORE_KEY);
  const y = Number(store.get(SCROLL_KEY + window.location.href));
  if (y > 0 && "scrollRestoration" in window.history) {
    // ブラウザが読み直し前の位置（前に見ていたページの位置）を戻してしまうので、この1回だけ止める
    window.history.scrollRestoration = "manual";
    window.addEventListener("load", () => {
      window.scrollTo(0, y);
      // load の中で auto に戻すと、そのあとブラウザが前の位置に戻してしまう。少し待ってから戻す
      setTimeout(() => { window.history.scrollRestoration = "auto"; }, 1000);
    }, { once: true });
  }
}
Turbolinks.start();
require("@rails/activestorage").start();
require("channels");

import $ from "jquery";
global.$ = global.jQuery = $;

import "bootstrap";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true);
// const imagePath = (name) => images(name, true);
